module.exports = __webpack_public_path__ + "img/icon_3.4e42582a.png";